/**
 * @file Ordered handler chain consumed by `callRunLanguageModel`. The first
 * handler whose `accepts` predicate matches the request shape wins; ordering
 * matters because `approvalResolved` and `task` are subsets of the broader
 * agentic and stream shapes and must be probed first. Adding a new request
 * shape means adding a handler here in the correct slot.
 */
import type { RequestUnion, ResponseHandler } from '../types';
import { taskHandler } from './taskHandler';
import { agenticHandler } from './agenticHandler';
import { streamHandler } from './streamHandler';
import { approvalResolvedHandler } from './approvalResolvedHandler';

export const cloudRunHandlers: ResponseHandler<RequestUnion>[] = [
    approvalResolvedHandler,
    taskHandler,
    agenticHandler,
    streamHandler,
];
